import type { SkipReason } from "@/lib/api/envoy";

/** The fixed reasons, as the skip dialog lists them. Nothing the person types is kept. */
export const SKIP_REASON_LABEL: Record<SkipReason, string> = {
    NOT_A_FIT: "Not a fit",
    PAY: "Pay",
    LOCATION: "Location",
    COMPANY: "Company",
    ALREADY_APPLIED: "Already applied",
    OTHER: "Other",
};
